<template>
  <v-phone-input
    v-model="phone"
    @update="update"
    size="lg"
    :color="color"
    :valid-color="colorValid"
    :error-color="colorError"
    :autofocus="autofocus"
    :required="required"
    no-example
    dynamic-placeholder
    enabled-country-code
    :dark="dark"
    :dark-color="'#1c1c1c'"
    :preferred-countries="['US', 'GB']"
  />
</template>

<script>
import { mdiPhone } from '@mdi/js'

export default {
  name: 'PhoneInput',
  data: () => ({
    phone: '',
    countryCodes: [
      {
        text: '+1',
        value: 'us'
      },
      {
        text: '+43',
        value: 'uk'
      }
    ],
    country: 'us'
  }),
  props: {
    value: String,
    autofocus: Boolean,
    required: Boolean,
    dark: Boolean,
    label: {
      type: String,
      default: 'Phone Number'
    }
  },
  computed: {
    icon () {
      return mdiPhone
    },
    color () {
      return this.$vuetify.theme.currentTheme.primary
    },
    colorValid () {
      return this.$vuetify.theme.currentTheme.success
    },
    colorInvalid () {
      return this.$vuetify.theme.currentTheme.error
    }
  },
  methods: {
    update (data) {
      console.log('data', JSON.stringify(data, null, 2))
      this.$emit('update', data)
      let output = ''
      if (data.countryCallingCode && data.nationalNumber) {
        output = `${data.countryCallingCode}${data.nationalNumber}`
      }
      console.log(`output -${output}-`)
      this.$emit('input', output)
    }
  }
}
</script>

<style scoped>
#app .is-focused > * {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
